<script setup>
import { computed } from 'vue';

const props = defineProps({
  agents: Array, // [{id, name, avatar_url, count, total_value}]
  title: String,
});

const maxToShow = 5;
const shownAgents = computed(() => props.agents.slice(0, maxToShow));
const extraCount = computed(() => props.agents.length > maxToShow ? props.agents.length - maxToShow : 0);
</script>

<template>
  <div>
    <h3 class="font-semibold text-base mb-2">{{ title }}</h3>
    <div class="flex flex-wrap gap-2">
      <div
        v-for="(agent, idx) in shownAgents"
        :key="agent.id"
        class="flex items-center gap-1 border border-slate-200 dark:border-slate-700 rounded-full px-2 py-1 bg-transparent text-xs text-slate-600 dark:text-slate-300 relative"
        :title="`#${idx+1} - ${agent.name}\nCards: ${agent.count}\nValor Total: ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(agent.total_value || 0)}`"
      >
        <span class="font-bold text-slate-500 mr-1">#{{ idx+1 }}</span>
        <img :src="agent.avatar_url" :alt="agent.name" class="w-6 h-6 rounded-full object-cover" />
        <span class="truncate max-w-[80px]">{{ agent.name }}</span>
        <span class="opacity-60">({{ agent.count }})</span>
        <span v-if="agent.total_value !== undefined" class="ml-1 text-green-700 dark:text-green-400 font-semibold">{{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(agent.total_value) }}</span>
      </div>
      <div v-if="extraCount > 0" class="flex items-center gap-1 border border-dashed border-slate-300 rounded-full px-2 py-1 bg-slate-100 dark:bg-slate-800 text-xs text-slate-400 ml-2">
        +{{ extraCount }} outros
      </div>
    </div>
  </div>
</template> 